import WatermarkModal from './WatermarkModal';

export default WatermarkModal;
